module.exports = __webpack_public_path__ + "static/media/Accepted.70b8d46a.svg";